import { useState, useEffect } from 'react';
import { Table, TableBody, TableCell, TableHeader, TableRow } from '@lmig/lmds-react-table';
import { Link } from '@lmig/lmds-react-link';
import './PolicyLookup.scss';
import { useUserData } from 'Foundation/User/UserContext';
import { Heading } from '@lmig/lmds-react-typography';
import { CircularProgressSpinner } from '@lmig/sales-ui-circular-progress-spinner';
import { getClaimURL } from 'Utilities/URLHelper';
import { SitecoreFetch } from 'Api/api/SitecoreApi';
import { HttpStatusCodes, IServerResponse } from 'Utilities/ClientResponseUtility';
import AccessDeniedMessage from './Helpers/AccessDeniedMessage';

function ClaimSummary(props: { policyNumber: string; callback: () => void }) {
  const [claims, setClaims] = useState<{ data?: IClaimsLookupResults[] | null; isLoaded: boolean }>({
    isLoaded: false,
  });
  const { userData } = useUserData();
  const [responseStatus, setResponseStatus] = useState<{ statusCode: number; message: string }>({
    statusCode: HttpStatusCodes.InternalServerError,
    message: '',
  });
  const defaultMessage = 'No claims activity found for this customer for the last 45 days.';

  useEffect(() => {
    const fetchData = async () => {
      setClaims({ isLoaded: false });
      let response = (await SitecoreFetch(
        `/api/sitecore/ClaimAsync/GetClaimsLookupResults?agencyNumber=${userData?.selectedStatCodeData?.SubStat}&policyNumber=${props.policyNumber}`,
      )) as IServerResponse;
      setResponseStatus({ statusCode: response.Status.Code, message: response.Status.Message });
      let result: IClaimsLookupResults[] | null;
      if (response.Status.Code === HttpStatusCodes.OK) result = response.Data as IClaimsLookupResults[];
      else result = null;
      setClaims({ data: result, isLoaded: true });
      props.callback();
    };

    try {
      fetchData();
    } catch (error) {
      console.error(error);
    }
  }, [props.policyNumber, userData?.selectedStatCodeData?.SubStat]);

  function openClaim(claimNumber: string) {
    if (userData) window.open(getClaimURL(claimNumber, userData), '', 'width=1000,height=800,left=0,top=50');
  }

  return (
    <>
      {userData && (
        <div>
          <Heading type="h4-light">Claims Summary</Heading>
          {!claims.isLoaded ? (
            <CircularProgressSpinner size="32" aria-label="Loading recent activities data..." />
          ) : claims.data && claims.data.length > 0 ? (
            <Table id="policy-lookup-claims-table" className="uscm-recent-activities-table">
              <TableHeader>
                <TableRow>
                  <TableCell type="colHead">Policy</TableCell>
                  <TableCell type="colHead">LOB</TableCell>
                  <TableCell type="colHead">Claim Number/Claimant Name</TableCell>
                  <TableCell type="colHead">Activity Date</TableCell>
                  <TableCell type="colHead">Status</TableCell>
                  <TableCell type="colHead">Activity Type</TableCell>
                  <TableCell type="colHead">Date of Loss</TableCell>
                </TableRow>
              </TableHeader>
              <TableBody>
                {claims.data.map((item, i) => (
                  <TableRow key={i}>
                    <TableCell>{item.PolicyNumber}</TableCell>
                    <TableCell>{item.LOB}</TableCell>
                    <TableCell>
                      <Link onClick={() => openClaim(item.ClaimNumberAndClaimantName)}>
                        {item.ClaimNumberAndClaimantName}
                      </Link>
                    </TableCell>
                    <TableCell>{item.ActivityDate}</TableCell>
                    <TableCell>{item.Status}</TableCell>
                    <TableCell>{item.ActivityType}</TableCell>
                    <TableCell>{item.DateOfLoss}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          ) : responseStatus.statusCode === HttpStatusCodes.OK ? (
            defaultMessage
          ) : (
            <AccessDeniedMessage
              status={responseStatus.statusCode}
              responseMessage={responseStatus.message}
              activityDataType={'claims'}
            ></AccessDeniedMessage>
          )}
        </div>
      )}
    </>
  );
}

export default ClaimSummary;
